












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({
  name: "calculator",
})
export default class cutOffLine extends Vue {
  private text = "";
  @Prop({ type: Object, default: {} })
  item!: any;
  @Watch("item", { immediate: true, deep: true })
  dataChage(value: any) {
    this.text = value.text;
  }
}
